// extracted by mini-css-extract-plugin
module.exports = {"s1qb2387":"s1qb2387"};